import { getParam } from '@tencent/midas-util'
import { getScript } from '@/api/util'
import { sandboxDailyUrl, sandboxFridayUrl, dailyUrl, fridayUrl } from '../constants/langs'

/**
 * 从 Window 上取相关配置内容
 */
function getWindowConfig() {
  return {
    daily: window.__midasStaticConfig_fuli_store_config,
    friday: window.__midasStaticConfig_fuli_friday_top_store
  }
}

/**
 * 通过前端 ajax 请求配置文件
 * 暂时不需要使用
 */
async function getScriptConfig({ daily, friday }) {
  await Promise.all([getScript(daily), getScript(friday)])
  return getWindowConfig()
}

/**
 * 获取配置文件
 * 若php直出未取到，则使用前端去请求
 * 请求时判断是否有sandbox参数，若有，则直接去调用沙箱url
 */
export default function getConfig(): Promise<DisplayConfig> {
  return new Promise((resolve, reject) => {
    let daily: string
    let friday: string
    const config = getWindowConfig()
    const sandbox = getParam('sandbox') * 1

    if (sandbox === 1) {
      daily = sandboxDailyUrl
      friday = sandboxFridayUrl

      getScriptConfig({ daily, friday })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    } else if (config && config.daily && config.daily.toolsId) {
      resolve(config)
    } else {
      // 兼容万一用php取不到的情况，就需要用ajax去请求
      daily = dailyUrl
      friday = fridayUrl

      getScriptConfig({ daily, friday })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    }
  })
}
